import { Injectable, Injector } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { NotifierService } from 'angular-notifier';
import { JoyrideService } from 'ngx-joyride';
import { FreeFormMinutesService } from './free-form-minutes.service';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class SideNavServiceService {

  //snackbar configuration
  horizontalPosition: MatSnackBarHorizontalPosition = 'start';
  verticalPosition: MatSnackBarVerticalPosition = 'bottom';
  dropdownDisable : any;
  meetingStarted = new BehaviorSubject<boolean>(false);

  private sidenav!: MatSidenav;
  //instant meeting variables
  instantMeeting = false

  //Pin div container variables
  backdropEnabler = false
  pinDiv = false

  //dialog checker variable
  dialogChecker = false;

  //panel expansion boolean setter
  panelExpand = false;
  panelBrowserExpand = false;

  //video section full panel expansion
  videoFullPanel = false;

  videoPanelOpenCloseStatus = false;

  //shortcut pin section
  shortCutDialogPinSection = false;

  tourStatusCheck = ''

  //instant meeting alerttourStatusChecker
  public alertSnackBar(message : any){
    this.notifier.show({
      type: 'warning',
      message: 'The Meeting Started'
    });
  }

  public alertLogout(message : any){
    this.notifier.show({
      type: 'success',
      message: 'You have been logged out.'
    });
  }
  public alertSchedule(message : any){
    this.notifier.show({
      type: 'success',
      message: 'Meeting Scheduled Successfully'
    });
  }
  public alertReschedule(message : any){
    this.notifier.show({
      type: 'success',
      message: 'Meeting Re-Scheduled Successfully'
    });
  }

  public alertSaveSettings(message : any){
    this.notifier.show({
      type: 'success',
      message: 'Data Saved Successfully'
    });
  }

  public alertAttendeeRole(message : any){
    this.notifier.show({
      type: 'error',
      message: 'Facilitator cannot be changed to NoteTaker or Attendee'
    });
  }

  public alertChangeFacilitator(message : any){
    this.notifier.show({
      type: 'error',
      message: 'Please add facilitator or make someone as chairperson'
    });
  }

  public alertChangeChairPerson(message : any){
    this.notifier.show({
      type: 'error',
      message: 'Please add chairperson or make someone as facilitator'
    });
  }

  public alertMultiFacilitator(message : any){
    this.notifier.show({
      type: 'error',
      message: 'Facilitator already exists. Please change to someother role'
    });
  }

  public alertSelectParticipantsSendMom(message : any){
    this.notifier.show({
      type: 'error',
      message: 'Please select a participants to complete it.'
    });
  }

  public alertMeetingApprove(message : any){
    this.notifier.show({
      type: 'success',
      message: 'Meeting Approved Successfully.'
    });
  }



  public alertSentMeetingDraft(message : any){
    this.notifier.show({
      type: 'success',
      message: 'MoM Draft Sent Successfully.'
    });
  }
  
  public alertMeetingReason(message : any, type: string){
    this.notifier.show({
      type: type,
      message: message
    });
  }

  public alertAddToTuleapTask(message : any){
    this.notifier.show({
      type: 'error',
      message: 'Assigned To and Due date are mandatory'
    });
  }
    //instant meeting checker
    public openInstantMeeting(instMeeting : any) {
      this.instantMeeting = instMeeting
    }

    public openInstantMeetingTransmitter() {
      return this.instantMeeting
    }

    //pin div setter
    public backdropValueTransmitter() {
      return this.backdropEnabler
    }

    public pinDivTriggerTransmitter() {
      return this.pinDiv
    }

    public pinDivTrigger(pinTrigger : any) {
      this.pinDiv = pinTrigger
    }

    public BackDropEnabler(backdropValue : any) {
      this.backdropEnabler = backdropValue
    }

    public setSidenav(sidenav: MatSidenav) {
        this.sidenav = sidenav;
    }

    //dialog checker
    public dialogCheckedChecker(bool : any){
        this.dialogChecker = bool;
    }

    public dialogCheckedEmitter(){
      return this.dialogChecker
    }

    public open() {
        return this.sidenav.open();
    }

    //tour trigger common function
    tourInitiator(){
      
      if(this.tourStatusCheck == 'instant'){
        this.joyrideService.startTour(
          { steps: ['meetFirstStep','meetSecondStep','meetDescFirstStep', 'meetDescSecondStep','meetParticipantFirstStep','meetAgendaFirstStep','meetAgendaTwoStep','meetAgendaThreeStep','meetAgendaFourStep','meetAgendaFiveStep','meetNoteOneStep','meetNoteTwoStep','meetNoteThreeStep','meetTaskOneStep','meetTaskTwoStep','meetTaskThreeStep','meetDecisionFirstStep','meetDecisionSecondStep','meetDecisionThirdStep','meetShotcutFirstStep','meetShortcutSecondStep'],waitingTime : 1,showCounter: false } // Your steps order
        ).subscribe(
          (step) => {
            const parentDiv = document.querySelector('.agendaRoot');
            const noteAccess = document.querySelector('.agPardNote')
            const decisionAccess = document.querySelector('.agPardDecision')
            const taskAccess = document.querySelector('.agPardTask')
            
            if(step.name == 'meetFirstStep'){
              document.getElementById('close-icon-desc')?.click()
            }
            if(step.name == 'meetSecondStep'){
              document.getElementById('edit-icon')?.click()
            }
            if(step.name == 'meetDescSecondStep'){
              document.getElementById('arrow-icon-check')?.click()
            }
            if(step.name == 'meetParticipantFirstStep'){
                if(document.getElementById('arrow-icon-check')?.innerText == 'keyboard_arrow_right'){
                  document.getElementById('arrow-icon-check')?.click()
                }
            }
            if(step.name == 'meetAgendaFiveStep' && step.actionType == 'NEXT' && (!parentDiv?.contains(noteAccess) && !parentDiv?.contains(decisionAccess) && !parentDiv?.contains(taskAccess))){
              setTimeout(() => {
                document.querySelectorAll('button').forEach((x,index) => {
                  x.style.visibility = 'hidden'
                })
              },500)             
              setTimeout(() => {
                  document.getElementById('tutorial')?.click()
              },1000)
              setTimeout(() => {
                document.getElementById('tutorial-notes')?.click()
                document.getElementById('tutorial-task')?.click()
                document.getElementById('tutorial-decision')?.click()
              },1000)
              setTimeout(() => {
                  document.getElementById('arrow-icon-check')?.click()
                  document.getElementById('edit-icon')?.click()
              },2000)
              setTimeout(() => {
                document.querySelectorAll('button').forEach((x,index) => {
                  x.style.visibility = 'visible'
                })
              },3000)
            }
            if(step.name == 'meetShortcutSecondStep'){
                document.getElementById('open-short-cut')?.click()
            }
          },
          (error) => {
          },
          () => {
              /*Tour is finished here, do something*/
        });
      }
      if(this.tourStatusCheck == 'schedule_meeting'){
        this.joyrideService.startTour(
          { steps: ['tourBeginner','meetFirstStep','meetSecondStep','meetDescFirstStep', 'meetDescSecondStep','meetParticipantFirstStep','meetAgendaFirstStep','meetAgendaThreeStep','meetAgendaFourStep','meetAgendaFiveStep','meetNoteOneStep','meetNoteTwoStep','meetNoteThreeStep','meetTaskOneStep','meetTaskTwoStep','meetTaskThreeStep','meetDecisionFirstStep','meetDecisionSecondStep','meetDecisionThirdStep','scheduleMeetingBtnOne','scheduleMeetingBtnTwo','meetShotcutFirstStep','meetShortcutSecondStep'],waitingTime : 0.0001,showCounter: false } // Your steps order
        ).subscribe(
          (step) => {
            const parentDiv = document.querySelector('.agendaRoot');
            const noteAccess = document.querySelector('.agPardNote')
            const decisionAccess = document.querySelector('.agPardDecision')
            const taskAccess = document.querySelector('.agPardTask')
            if(step.name == 'meetFirstStep'){
              document.getElementById('close-icon-desc')?.click()
            }
            if(step.name == 'meetSecondStep'){
              document.getElementById('edit-icon')?.click()
            }
            if(step.name == 'meetDescFirstStep'){
              
            }
            if(step.name == 'meetParticipantFirstStep'){
              if(document.getElementById('arrow-icon-check')?.innerText == 'keyboard_arrow_right'){
                document.getElementById('arrow-icon-check')?.click()
              }
            }
            if(step.name == 'meetAgendaFirstStep'){
              if(document.getElementById('arrow-icon-check')?.textContent != 'keyboard_arrow_down'){
                document.getElementById('arrow-icon-check')?.click()
              }
            }
            if(step.name == 'meetAgendaFiveStep' && step.actionType == 'NEXT' && (!parentDiv?.contains(noteAccess) && !parentDiv?.contains(decisionAccess) && !parentDiv?.contains(taskAccess))){
              setTimeout(() => {
                document.querySelectorAll('button').forEach((x,index) => {
                  x.style.visibility = 'hidden'
                })
              },500)             
              setTimeout(() => {
                  document.getElementById('tutorial')?.click()
              },1000)
              setTimeout(() => {
                document.getElementById('tutorial-notes')?.click()
                document.getElementById('tutorial-task')?.click()
                document.getElementById('tutorial-decision')?.click()
              },1000)
              setTimeout(() => {
                  document.getElementById('arrow-icon-check')?.click()
                  document.getElementById('edit-icon')?.click()
              },2000)
              setTimeout(() => {
                document.querySelectorAll('button').forEach((x,index) => {
                  x.style.visibility = 'visible'
                })
              },3000)
            }
            if(step.name == 'meetShortcutSecondStep'){
                document.getElementById('open-short-cut')?.click()
            }
          },
          (error) => {
          },
          () => {
              /*Tour is finished here, do something*/
              this.joyrideService.closeTour()
        });
      }
      if(this.tourStatusCheck == 'past'){
        this.joyrideService.startTour(
          { steps: ['tourBeginner','pastInitialStep','pastSecondOneStep','pastSecondStep','pastThirdStep'],waitingTime : 0.01,showCounter: false } // Your steps order
        ).subscribe(
          (step) => {
            if(step.name == 'meetFirstStep'){
              document.getElementById('close-icon-desc')?.click()
            }
            if(step.name == 'meetSecondStep'){
              document.getElementById('edit-icon')?.click()
            }
            if(step.name == 'meetDescSecondStep'){
            }
            if(step.name == 'meetParticipantFirstStep'){
              if(document.getElementById('arrow-icon-check')?.innerText == 'keyboard_arrow_right'){
                document.getElementById('arrow-icon-check')?.click()
              }
            }
            if(step.name == 'meetAgendaFiveStep'){
              setTimeout(() => {
                  document.getElementById('tutorial')?.click()
              },1000)
              setTimeout(() => {
                document.getElementById('tutorial-notes')?.click()
                document.getElementById('tutorial-task')?.click()
                document.getElementById('tutorial-decision')?.click()
              },1000)

            }
            if(step.name == 'meetShortcutSecondStep'){
                document.getElementById('open-short-cut')?.click()
            }
          },
          (error) => {
          },
          () => {
            this.joyrideService.closeTour()
              /*Tour is finished here, do something*/
        });
      }
      if(window.location.pathname.includes('/dashboard') && !this.instantMeeting){
        this.joyrideService.startTour(
          { 
            steps: ['layoutFirstStep', 'layoutSecondStep','layoutThirdStep','layoutFourthStep','layoutFifthStep','layoutSixStep','layoutSevenStep','layoutEightStep','layoutNineStep','layoutTenthStep','layoutElevenStep', 'layoutTweleveStep','dashboardFirstStep','dashboardSecondStep','dashboardThirdStep','dashboardFourthStep','dashboardFifthStep'],
            waitingTime : 0.01,
            showCounter: false,
          } 
        ).subscribe(
          (step) => {
            const intervalId = setInterval(function() {
              if(step.name == 'dashboardFirstStep'){
                const element = $('#upcoming-meeting-joy');
                if (element) {
                  element[0].scrollIntoView();
                  clearInterval(intervalId);
                }
              }
              if(step.name == 'dashboardSecondStep'){
                const element = $('#task-joy');
                if (element) {
                  element[0].scrollIntoView();
                  clearInterval(intervalId);
                }
              }
            }, 0);
          },
          (error) => {

          },
          () => {
            this.joyrideService.closeTour()
          }
        )
      } 
      if(window.location.pathname.includes('/search')){
        this.joyrideService.startTour(
          { steps: ['searchFirstStep','searchSecondStep','searchThirdStep','searchFourthStep', 'searchFiveStep','searchSixStep','searchSevenStep','searchEightStep','searchNineStep','searchTenStep','searchElevenStep','searchTwelveStep'],waitingTime : 0.01,showCounter: false } // Your steps order
        ).subscribe(
          (step) => {
            if(step.name == 'meetSecondStep'){
              document.getElementById('edit-icon')?.click()
            }
            if(step.name == 'meetDescSecondStep'){
              document.getElementById('arrow-icon-check')?.click()
            }
            if(step.name == 'meetParticipantFirstStep'){
              document.getElementById('close-icon-desc')?.click()
            }
            if(step.name == 'meetAgendaFiveStep'){
              setTimeout(() => {
                  document.getElementById('tutorial')?.click()
              },1000)
              setTimeout(() => {
                document.getElementById('tutorial-notes')?.click()
                document.getElementById('tutorial-task')?.click()
                document.getElementById('tutorial-decision')?.click()
              },1000)
              
            }
            if(step.name == 'meetShortcutSecondStep'){
                document.getElementById('open-short-cut')?.click()
            }
          },
          (error) => {
          },
          () => {
              /*Tour is finished here, do something*/
          });
      }
      if(window.location.pathname.includes('/tasks')){
        this.joyrideService.startTour(
          { steps: ['taskFirstStep','taskSecondStep','taskThirdStep','taskFourthStep', 'taskFiveStep','taskSixStep','taskSevenStep','taskEightStep','taskNineStep','taskTenStep'],waitingTime : 0.01,showCounter: false } // Your steps order
        ).subscribe(
          (step) => {
            if(step.name == 'meetSecondStep'){
              document.getElementById('edit-icon')?.click()
            }
            if(step.name == 'meetDescSecondStep'){
              document.getElementById('arrow-icon-check')?.click()
            }
            if(step.name == 'meetParticipantFirstStep'){
              document.getElementById('close-icon-desc')?.click()
            }
            if(step.name == 'meetAgendaFiveStep'){
              setTimeout(() => {
                  document.getElementById('tutorial')?.click()
              },1000)
              setTimeout(() => {
                document.getElementById('tutorial-notes')?.click()
                document.getElementById('tutorial-task')?.click()
                document.getElementById('tutorial-decision')?.click()
              },1000)

            }
            if(step.name == 'meetShortcutSecondStep'){
                document.getElementById('open-short-cut')?.click()
            }
          },
          (error) => {
          },
          () => {
              /*Tour is finished here, do something*/
          });
      }
    }

    public close() {
        return this.sidenav.close();
    }

    public toggle(): void {
    this.sidenav.toggle();
   }

   public closeAllAccordtion(){
    let closeIcon = <HTMLElement>document.getElementById('close-icon-desc');
    if(closeIcon!=null){
      closeIcon.click();
    }
    let arrowIcon = <HTMLElement>document.getElementById('participant-accordion-container');
    let arrowIconCheck = <HTMLElement>document.getElementById('arrow-icon-check');
    let iconName = arrowIconCheck.textContent
    if(iconName == 'keyboard_arrow_down'){
      arrowIcon.click()
    }
   }

   public smootherScroll(elem : any){
    document.getElementById(elem.getAttribute('id'))?.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"})
   }

   public idSmooterScroll(id : any){
    document.getElementById(id)?.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"})
   }

   public bringPointer(id : any){
   }

    private readonly notifier!: NotifierService;
    constructor(private injector:Injector,private readonly joyrideService: JoyrideService,notifierService: NotifierService, private _snackBar: MatSnackBar) { 
    this.notifier = notifierService;

  }

  public disableDropdown(event : any){
    this.dropdownDisable = event
  }

  public disableDropdownTransmitter(){
    return this.dropdownDisable
  }

  public disablePages(){
    setTimeout(() => {
      document.querySelectorAll('[contenteditable=true]').forEach(x => {
        x.setAttribute('contenteditable','false')
      })
    },500)
    let agendaCount = document.getElementsByClassName('agendaTitleCls')
    for(var i = 0; i < agendaCount.length; i ++){
      agendaCount[i].setAttribute('style','pointer-events : none')
    }
    document.querySelectorAll('button').forEach(x => {
      x.setAttribute( 'disabled','true')
    })
    document.querySelectorAll('input').forEach(x => {
      x.setAttribute('disabled','true')
    })
    document.querySelectorAll('textarea').forEach(x => {
      x.setAttribute('disabled','true')
    })
    document.querySelectorAll('a').forEach(x => {
      x.style.pointerEvents = 'none'
    })
    this.disableDropdown(true)
    let layoutItems = document.getElementsByClassName('parent')
    for(let i = 0; i < layoutItems.length; i ++){
      layoutItems[i].setAttribute('style','pointer-events : none')
    }
    let task = document.getElementsByClassName('agPardTask');
    for(var i = 0; i < task.length; i ++){
      task[i].setAttribute('style','pointer-events : none')
    }
    let note = document.getElementsByClassName('agPardNote');
    for(var i = 0; i < note.length; i ++){
      note[i].setAttribute('style','pointer-events : none')
    }
    let decision = document.getElementsByClassName('agPardDecision');
    for(var i = 0; i < note.length; i ++){
      note[i].setAttribute('style','pointer-events : none')
    }
    document.getElementById('profile-btn')?.removeAttribute('disabled')
    document.getElementById('logout-btn')?.removeAttribute('disabled')
  }


  public disablePageAfterApproval(){
    setTimeout(() => {
      $('[contenteditable=true]:not(.agChildTask)').addClass("disableAfterApproveCls");
      $('[contenteditable=true]:not(.agChildTask)').attr('contenteditable','false');
      $('.disableAfterApprove,.disableAfterApprove input:not(.allowAfterApprove),.disableAfterApprove textarea:not(.allowAfterApprove),.disableAfterApprove .mat-icon-button:not(.allowAfterApprove)').addClass("disableAfterApproveCls");
    },5)
    
  }
  enableAfterApproveToNormal(){
    setTimeout(() => {
      $(".disableAfterApproveCls[contenteditable=false]").attr("contenteditable","true");
      $(document).find(".disableAfterApproveCls").removeClass("disableAfterApproveCls");    
    }, 50);
  }


  public restrictGuestUserMessage(){
    this.notifier.show({
      type: 'error',
      message: 'User does not have rights'
    });
  }

  public expandFullScreenBooleanSetter(bool : any, id : any, idTwo : any){
    this.panelExpand = bool;
    if(bool){
      document.getElementsByClassName('ng-scroll-viewport')[0].classList.add('removeScroll')
      if(id != '' || idTwo != ''){
        document.getElementsByClassName(id)[0].classList.add(idTwo)
        document.getElementsByClassName(id)[0].scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"})
      }
    }
    else{
        document.getElementsByClassName('ng-scroll-viewport')[0].classList.remove('removeScroll')
      if(id != '' || idTwo != ''){
        document.getElementsByClassName(id)[0].classList.remove(idTwo)
        document.getElementsByClassName(id)[0].classList.remove('panel-fullscreen')
        document.getElementsByClassName(id)[0].classList.remove('panel-fullscreen-mb-view')
      }
    }
  }

  public expandBrowserFullScreenSetter(bool : any){
    this.panelBrowserExpand = bool;
    if(bool){
      document.getElementById('root-element')?.requestFullscreen()
    }
    else{
      document.exitFullscreen()
    }
  }

  public returnExpandFullScreeBooleanSetter(){
    return this.panelExpand
  }

  public returnExpandBrowserFullScreenSetter(){
    return this.panelBrowserExpand
  }

  public videoFullScreenExpansionSetter(bool : any, id : any){
    this.videoFullPanel = bool;
    
    if(bool){
      if(document.getElementsByClassName('example-sidenav')[0] != undefined){
        document.getElementsByClassName('example-sidenav')[0].classList.add('hide-navigation-bar-large-screen');
      }
      if(document.getElementsByClassName('header-container-main')[0] != undefined){
        document.getElementsByClassName('header-container-main')[0].classList.add('hide-navigation-bar-large-screen')
      }
      if(document.getElementsByClassName('mat-sidenav-content')[0] != undefined){
        document.getElementsByClassName('mat-sidenav-content')[0].setAttribute('style','margin-left : 0px')
      }
      if(document.getElementsByClassName('footer')[0] != undefined){
        document.getElementsByClassName('footer')[0].classList.add('hide-navigation-bar-large-screen')
      }
    }
    else if(!bool){
      if(document.getElementsByClassName('example-sidenav')[0] != undefined){
        document.getElementsByClassName('example-sidenav')[0].classList.remove('hide-navigation-bar-large-screen');
      }
      if(document.getElementsByClassName('header-container-main')[0] != undefined){
        document.getElementsByClassName('header-container-main')[0].classList.remove('hide-navigation-bar-large-screen')
      }
      if(document.getElementsByClassName('mat-sidenav-content')[0] != undefined){
        document.getElementsByClassName('mat-sidenav-content')[0].setAttribute('style','margin-left : 65px')
      }
      if(document.getElementsByClassName('footer')[0] != undefined){
        document.getElementsByClassName('footer')[0].classList.remove('hide-navigation-bar-large-screen')
      }
    }

    if(bool){
      if(document.getElementsByClassName('example-sidenav')[0] != undefined){
        document.getElementsByClassName('example-sidenav')[0].classList.add('hide-navigation-bar-large-screen');
      }
      if(document.getElementsByClassName('header-container-main')[0] != undefined){
        document.getElementsByClassName('header-container-main')[0].classList.add('hide-navigation-bar-large-screen')
      }
      if(document.getElementsByClassName('mat-sidenav-content')[0] != undefined){
        document.getElementsByClassName('mat-sidenav-content')[0].setAttribute('style','margin-left : 0px')
      }
      if(document.getElementsByClassName('layout-footer')[0] != undefined){
        document.getElementsByClassName('layout-footer')[0].classList.add('hide-navigation-bar-large-screen')
      }
    }
    else if(!bool){
      if(document.getElementsByClassName('example-sidenav')[0] != undefined){
        document.getElementsByClassName('example-sidenav')[0].classList.remove('hide-navigation-bar-large-screen');
      }
      if(document.getElementsByClassName('header-container-main')[0] != undefined){
        document.getElementsByClassName('header-container-main')[0].classList.remove('hide-navigation-bar-large-screen')
      }
      if(document.getElementsByClassName('mat-sidenav-content')[0] != undefined){
        document.getElementsByClassName('mat-sidenav-content')[0].setAttribute('style','margin-left : 0px')
      }
      if(document.getElementsByClassName('layout-footer')[0] != undefined){
        document.getElementsByClassName('layout-footer')[0].classList.remove('hide-navigation-bar-large-screen')
      }
    }

    setTimeout(() => {
      var minutesService = this.injector.get(FreeFormMinutesService);
            minutesService.destroyCkInstane('minComCls');
            minutesService.activateAllCkeditor('minComCls');
    }, 500);
  }

  public returnVideoFullScreenExpansionSetter(){
    return this.videoFullPanel;
  }

  public setVideoPaneOpenCloseStatus(bool : any){
    this.videoPanelOpenCloseStatus = bool
  }

  public getVideoPaneOpenCloseStatus(){
    return this.videoPanelOpenCloseStatus;
  }

  public htmlTagRemoverContent(str : any){
    return str.toString().replace( /(<([^>]+)>)/ig, '')
  }

  public pinShortCutDialog(bool : any){
    this.shortCutDialogPinSection = bool
  }

  public returnPinShortCutDialog(){
    return this.shortCutDialogPinSection
  }

  public setTourStatusChecker(status : any){
    this.tourStatusCheck = status
  }

  public returnTourStatusChecker(){
    return this.tourStatusCheck
  }

  public alertPhemeSuccess(message : any){
    this.notifier.show({
      type: 'success',
      message: message
    });
  }

  public alertPhemeError(message : any){
    this.notifier.show({
      type: 'error',
      message: message
    });
  }
  public alertNotifySuccess(message:any){
    this.notifier.show({
      type: 'success',
      message: message
    });
  }
  public alertNotifyError(message:any){
    this.notifier.show({
      type: 'error',
      message: message
    });
  }
}
